import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Field, FieldMap, Rule} from "../../../_typing/query-builder";
import {BaseComponent} from "../../../shared/base.component";
import {deepCopy} from "../../../lib/utils";
import {ValidationFieldOptionComponent} from "./validation-field-option/validation-field-option.component";
import {ValidationQueryOperatorComponent} from "./validation-query-operator/validation-query-operator.component";
import {ValidationQueryValueComponent} from "./validation-query-value/validation-query-value.component";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";

@Component({
    selector: 'validation-rule',
    templateUrl: './validation-rule.component.html',
    styleUrls: [ '../validation-rule-set/validation-rule-set.component.scss'],
    imports: [
        MatIcon,
        MatIconButton,
        ValidationFieldOptionComponent,
        ValidationQueryOperatorComponent,
        ValidationQueryValueComponent
    ],
    encapsulation: ViewEncapsulation.None
})
export class ValidationRuleComponent extends BaseComponent {
    @Input() rule: Rule;
    @Input() readonly fields: FieldMap;
    @Output() removeRuleRequest: EventEmitter<void> = new EventEmitter();

    selectedField: Field;

    constructor() {
        super();
    }

    ngOnInit() {
        this.selectedField = deepCopy(this.fields[this.rule.field]);
    }

    removeRule() {
        this.removeRuleRequest.next();
    }
}
